import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const HistoryPagination = ({
    page,
    pageSize,
    totalPages,
    totalItems,
    onPageChange,
    onPageSizeChange,
}) => {
    if (totalPages <= 1) return null;

    return (
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white/85 px-4 py-3 backdrop-blur">
            <div className="text-xs text-slate-600">
                <span
                    className="font-semibold"
                    data-testid="history-pagination-current-page"
                >
                    Page {page} of {totalPages}
                </span>
                <span className="ml-2 text-slate-400">
                    ({totalItems} total items)
                </span>
            </div>
            <div className="flex items-center gap-2">
                <label className="flex items-center gap-2 text-xs text-slate-600">
                    Per page
                    <select
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}
                        data-testid="history-pagination-page-size"
                        className="h-8 rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-blue-500/40"
                    >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </label>
                <button
                    type="button"
                    onClick={() => onPageChange(page - 1)}
                    disabled={page <= 1}
                    data-testid="history-pagination-prev"
                    className="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200 bg-white px-2 text-xs font-semibold text-slate-700 hover:bg-slate-100 disabled:opacity-40"
                >
                    <ChevronLeft className="h-3.5 w-3.5" />
                    Prev
                </button>
                <button
                    type="button"
                    onClick={() => onPageChange(page + 1)}
                    disabled={page >= totalPages}
                    data-testid="history-pagination-next"
                    className="inline-flex h-8 items-center gap-1 rounded-md border border-slate-200 bg-white px-2 text-xs font-semibold text-slate-700 hover:bg-slate-100 disabled:opacity-40"
                >
                    Next
                    <ChevronRight className="h-3.5 w-3.5" />
                </button>
            </div>
        </div>
    );
};

export default HistoryPagination;
